import { getLeftNavGroupFoldersStore } from '../store/store';

export function getGroupFolderName(groupId: string, folderId: string): string {
    if (groupId && folderId) {
        const folderHierarchy = getLeftNavGroupFoldersStore().folderTable?.get(
            groupId.toLowerCase()
        )?.folderHierarchy;

        return folderHierarchy?.get(folderId)?.DisplayName ?? '';
    }

    return '';
}
